import {
  Button,
  Card,
  Col,
  Row,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {  VIEW_COURSE } from "../../apis/apis";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import CulsightPageLoader from "../../components/CulsightPageLoader";
//import CustomRichTextEditor from "../../components/CustomTextEditor";

function CourseDetails(props) {
  const { id } = useParams();
  const location = useLocation();
  //const { notification, message } = App.useApp();
  const Navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(true);
  const [image_loader, set_image_loader] = useState(false)
  const [course_data, set_course_data] = useState({});
  // const [card_loader, set_card_loader] = useState(true);
  //const [description, set_description] = useState("");
  // const [comments, set_comments] = useState([]);
  // const [current_page, set_current_page] = useState(1);
  // const [total_comments, set_total_comments] = useState(0);
  // const [total_pages, set_total_pages] = useState(1);

  const handleBack = () => {
    if (location.state?.from) Navigate(location.state.from);
    else Navigate(-1);
  };


  // Fetch course details
  useEffect(() => {
    const VIEW_API = async () => {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      const res = await VIEW_COURSE(FORM_DATA);
      if (res?.data?.status) {
        set_course_data(res.data.data);
      }
      set_page_loader(false);
    };
    VIEW_API();
  }, [id]);

  // Fetch comments list
  // const fetchCommentList = useCallback(
  //   async (page = 1) => {
  //     const FORM_DATA = new FormData();
  //     FORM_DATA.append("view_id", atob(id));
  //     FORM_DATA.append("page", page);
  //     FORM_DATA.append("comment_type", "course");

  //     try {
  //       const API_CALL = await LIST_COMMENT(FORM_DATA);
  //       if (API_CALL?.data?.status) {
  //         const data = API_CALL.data;
  //         set_comments(data.comments || []);
  //         set_current_page(data.page || 1);
  //         set_total_comments(data.total_comments || 0);
  //         set_total_pages(data.total_pages || 1);
  //       } else {
  //         set_comments([]);
  //       }
  //     } catch (error) {
  //       console.error("Network error:", error);
  //     } finally {
  //       set_card_loader(false);
  //     }
  //   },
  //   [id]
  // );

  // useEffect(() => {
  //   fetchCommentList();
  // }, [fetchCommentList]);


  return (
    <div className="lms-body">
      {page_loader ? (
        <CulsightPageLoader />
      ) : (
        <div>
          <Card>
            <Row>
              <Col lg={12} xs={12} sm={12}>
                <h3
                  onClick={handleBack}
                  style={{
                    marginTop: "-10px",
                    marginBottom: "5px",
                    cursor: "pointer",
                  }}
                >
                  <LeftOutlined /> Go Back
                </h3>
              </Col>
              <Col lg={12} xs={12} sm={12}>
                <Button
                  style={{
                    float: "right",
                    marginTop: "-10px",
                    marginBottom: "10px",
                  }}
                  type="primary"
                  onClick={() => {
                    Navigate("/chapters/" + btoa(course_data.id), {
                      state: { title: course_data.title },
                      from: window.location.pathname,
                    });
                  }}
                >
                  Start Learning 
                </Button>
              </Col>
            </Row>

            <Row gutter={30}>
              <Col  lg={12} xs={24} sm={24} style={{ marginBottom: "30px" }}>
                <div style={{ width: "100%", position: "relative", borderRadius: 8, overflow: "hidden" }}>
                  <div
                    style={{
                      width: "100%",
                      aspectRatio: "16 / 9",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 8,
                    }}
                  >
                    {!image_loader && (
                      <Spin
                        indicator={<LoadingOutlined style={{ fontSize: 28, color: "#0a8ce9ff" }} spin />}
                      />
                    )}

                    <img
                      src={course_data.thumbnail}
                      alt="Course Thumbnail"
                      onLoad={() => set_image_loader(true)}
                      onError={() => set_image_loader(false)}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 8,
                        display: image_loader ? "block" : "none",
                      }}
                    />
                  </div>
                </div>
              </Col>

              <Col  lg={12} xs={24} sm={24}>
                <h2 style={{ textTransform: "capitalize" }}>{course_data.title}</h2>
                <p>
                  <b style={{ color: "#1fa7a1" }}>Instructor:</b>{" "}
                  {course_data.instructor_display_name}
                </p>
                <p>
                  <b style={{ color: "#1fa7a1" }}>Language:</b>{" "}
                  {course_data.language}
                </p>
                <p>
                  <b style={{ color: "#1fa7a1" }}>Duration:</b>{" "}
                  {course_data.course_duration}
                </p>
              </Col>
            </Row>

            <h3 style={{ color: "#1fa7a1" }}>Description</h3>
            <div dangerouslySetInnerHTML={{ __html: course_data.description }} />

            {/* Comment Section */}
            {/* <div style={{ marginTop: "30px" }} >
              <CustomRichTextEditor
                editorLabel="Course Discussions"
                value={description}
                onChange={(val) => set_description(val)}
                placeholder="Write something..."
              />
              <Button
                type="primary"
                style={{ marginTop: "-20px" }}
                onClick={onFinish}
                loading={card_loader}
              >
                Submit
              </Button>

              <List
                itemLayout="horizontal"
                dataSource={comments}
                style={{ marginTop: "20px" }}
                locale={{ emptyText: "No discussions yet." }}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar>{item.first_name?.[0]}</Avatar>}
                      title={<b>{item.first_name + " " + item.last_name}</b>}
                      description={
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                          <small style={{ color: "#888" }}>
                            {formatTime(item.created_at)}
                          </small>
                        </>
                      }
                    />
                  </List.Item>
                )}
              />

              {total_pages > 1 && (
                <div style={{ float: "right", marginTop: "20px" }}>
                  <Pagination
                    current={current_page}
                    total={total_comments}
                    pageSize={10}
                    onChange={pagination_on_change}
                  />
                </div>
              )}
            </div> */}

          </Card>
        </div>
      )}
    </div>
  );
}

export default CourseDetails;
